import React from 'react';

export default function PrimaryLabel({ label }) {
    return (
        <div className="primary-label-container">
            <div className="primary-label form-section">{label}</div>
        </div>
    )
}
